import { render, staticRenderFns } from "./AutoSaveTextArea.vue?vue&type=template&id=f1b21272&"
import script from "./AutoSaveTextArea.vue?vue&type=script&lang=js&"
export * from "./AutoSaveTextArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports